import React from 'react'

const ExchangeRate = ({exchangeRate, chosenPrimaryCurrency, chosenSecondaryCurrency}) => {
    return (
        <div className='exchange'>
            <h3 className='m-5 font-bold' style={{textAlign: "center", fontSize: '1.5rem'}}>ExchangeRate</h3>
            <h1 className='m-5' style={{textAlign: "center", color: 'tomato', fontSize: '2rem'}} >{exchangeRate}</h1>
            <p className='m-5' style={{textAlign: "center"}} >{chosenPrimaryCurrency} to {chosenSecondaryCurrency}</p>
        </div>
    )
}

export default ExchangeRate
